import React, { FC } from 'react'
import s from './ModalFeedbackSelection.module.sass'
import { Modal } from '@shared/ui/Overlays/Modal'
import { closeModal } from '@widgets/Common/ModalFeedback/model/actions'
import { Text } from '@shared/ui/Typography/Text'
import { Button } from '@shared/ui/Actions/Button'
import { ErrorBoundary } from '@shared/lib/components/ErrorBoundary'
import { useAppDispatch, useAppSelector } from '@app/model/store'
import { FEEDBACK_CATEGORIES } from '@widgets/Common/ModalFeedback/const/categories'
import { setCategory } from '@widgets/Common/ModalFeedback/model/slice'
import { useClientResponsive } from '@shared/lib/hooks/useClientResponsive'
import useFeatureFlag from '@shared/lib/hooks/useFeatureFlag'

const ModalFeedbackSelection: FC = () => {
  const { isMobile } = useClientResponsive()
  const dispatch = useAppDispatch()

  const handleSelect = (category) => {
    if (category.externalLink) {
      window.open(category.externalLink, '_blank')
      return
    }

    dispatch(setCategory(category.type))
  }

  const userData = useAppSelector((state) => !!state.global?.user?.data)
  const assistFlag = useFeatureFlag('gigachat')
  const isAssistantActive = userData || assistFlag

  const feedbackThemeList = Object.values(FEEDBACK_CATEGORIES).filter((el) => {
    if (el.type == 'aiAssistantQuestion' && !isAssistantActive) return false
    return true
  })

  return (
    <ErrorBoundary>
      <Modal
        data-testid={'modal-found-mistake'}
        data-modal={'Обратная связь'}
        title={'Обратная связь'}
        subtitle={
          <Text sizes={'M'} className={s.description}>
            Выберите интересующий вас вопрос или проблему {!isMobile && <br />}
            из списка ниже
          </Text>
        }
        size={'S'}
        handleClose={() => dispatch(closeModal())}
        className={s.modal}>
        <div className={s.content}>
          {feedbackThemeList.map((category) => (
            <button onClick={() => handleSelect(category)} className={s.button} key={category.type}>
              <Text sizes={'M'} tag={'span'} className={s['button-text']}>
                {category.title}
              </Text>
            </button>
          ))}
        </div>
      </Modal>
    </ErrorBoundary>
  )
}

export default ModalFeedbackSelection
